import { DeleteButton, MoreActionsTitle, DeleteActionWrapper } from '../../../../modules/entities/EditHoldingEntity/EditHoldingEntity.styles';
import { DefaultEntityAction } from './DefaultEntityAction';

export const HoldingEntityMoreActions = ({ isEdit, holdingEntityData, onDefaultEntityChange, mobileViewDeleteHoldingEntity }) => {
  return (
    <div style={{ width: '100%', padding: '16px 0' }}>
      {
        isEdit &&
        <MoreActionsTitle>More actions</MoreActionsTitle>
      }

      <DefaultEntityAction
        holdingEntityData={holdingEntityData}
        onDefaultEntityChange={onDefaultEntityChange}
      />
      {
        isEdit &&
        <DeleteActionWrapper>
          <DeleteButton onClick={mobileViewDeleteHoldingEntity}>
            <EraseHoldingEntitySvg />
            Delete entity
          </DeleteButton>
        </DeleteActionWrapper>
      }
    </div>
  )
}

export const EraseHoldingEntitySvg = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.75 9.5C18.75 9.5 18.2262 15.9022 17.9194 18.9881C17.869 19.4947 17.4419 19.8757 16.9328 19.876L8.15189 19.8811C7.64227 19.8814 7.2143 19.5 7.16174 18.9931C6.84059 15.8953 6.25 9.5 6.25 9.5" stroke="#FF0000" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
      <path d="M20 6.55469H5" stroke="#FF0000" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
      <path d="M17 6.55288C15.9225 6.55288 15.5944 5.67353 15.542 4.75719C15.504 4.09153 15.0116 3.5 14.3448 3.5H10.6552C9.98842 3.5 9.49604 4.09153 9.45799 4.75719C9.40562 5.67353 9.07753 6.55288 8 6.55288" stroke="#FF0000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}